import { render, staticRenderFns } from "./commonTips.vue?vue&type=template&id=7350ff22&scoped=true&"
import script from "./commonTips.vue?vue&type=script&lang=js&"
export * from "./commonTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350ff22",
  null
  
)

export default component.exports